import { map } from 'lodash';
/**
 * We're using the "select" function here to extract the row count.
 */
export const makeSelect = (selectFromOptions) => (data) => {
    const allData = map(data.pages, page => {
        return page.value;
    });
    const value = Object.assign(Object.assign({}, data), { pages: allData });
    return selectFromOptions ? selectFromOptions(value) : value;
};
